import {createApp} from 'vue/dist/vue.esm-bundler'

import {VueMasonryPlugin} from "vue-masonry";


// ensure the main object is defined
if (typeof (so) === 'undefined') {
    var so = {};
}

so.project_listing = createApp({
    data: function () {
        return {
            loaded: false
        }
    },
    mounted: function () {
        this.init();
    },
    methods: {
        init: function () {
            this.$nextTick(() => {
                this.loaded = true;
            });
        }
    }


}).use(VueMasonryPlugin).mount('#feature-list-icon-card-stack');



$(window).ready(function () {

});
